
import axios from 'axios';
import { get } from 'lodash';
import { URL } from 'config/config';
import { showAlert } from './alert';

export const SET_SUPER_ADMIN_PREFERENCES = 'SET_SUPER_ADMIN_PREFERENCES';
export const SET_SUPER_ADMIN_PREFERENCES_LOADING = 'SET_SUPER_ADMIN_PREFERENCES_LOADING';

export const SET_NOTIF_LISTS = 'SET_NOTIF_LISTS';
export const SET_NOTIF_LISTS_LOADING = 'SET_NOTIF_LISTS_LOADING';

export const SET_FILTERED_CUSTOMER_REVIEWS = 'SET_FILTERED_CUSTOMER_REVIEWS';
export const SET_FILTERED_CUSTOMER_REVIEWS_LOADING = 'SET_FILTERED_CUSTOMER_REVIEWS_LOADING';


const setSuperAdminPreferences = payload => ({
    type: SET_SUPER_ADMIN_PREFERENCES,
    payload
});
const setSuperAdminPreferencesLoading = (value = true) => ({
    type: SET_SUPER_ADMIN_PREFERENCES_LOADING,
    payload: value
});
const setNotificationLists = payload => ({
    type: SET_NOTIF_LISTS,
    payload
});
const setNotificationListsLoading = (value = true) => ({
    type: SET_NOTIF_LISTS_LOADING,
    payload: value
});
const setFilteredCustomerReviews = payload => ({
    type: SET_FILTERED_CUSTOMER_REVIEWS,
    payload
});
const setFilteredCustomerReviewsLoading = (value = true) => ({
    type: SET_FILTERED_CUSTOMER_REVIEWS_LOADING,
    payload: value
});




export const fetchSuperAdminPreferences = () => async dispatch => {
    try {
        dispatch(setSuperAdminPreferencesLoading(true));
        const response = await axios.get(URL.SUPERADMIN_PREFERENCES)
        if (response && response.data.success) {
            const data = get(response, 'data.object', {});
            dispatch(setSuperAdminPreferences(data));
            dispatch(setSuperAdminPreferencesLoading(false));
            return data
        }
        dispatch(setSuperAdminPreferencesLoading(false));
    } catch (err) {
        dispatch(setSuperAdminPreferencesLoading(false));
        if (err?.message) {
            dispatch(showAlert('error', err?.message))
        }
    };
};

export const updateSuperAdminPreferences = (payload) => async dispatch => {
    try {
        dispatch(setSuperAdminPreferencesLoading(true));
        const response = await axios.post(URL.SUPERADMIN_PREFERENCES, payload);
        if (response && response.data.success) {
            const data = get(response, 'data.object', {});
            dispatch(setSuperAdminPreferences(data))
            dispatch(setSuperAdminPreferencesLoading(false));
            return data
        } else if (response?.data?.message) {
            dispatch(showAlert('error', response?.data?.message))
        }
        dispatch(setSuperAdminPreferencesLoading(false));
    } catch (err) {
        dispatch(setSuperAdminPreferencesLoading(false));
        if (err?.message) {
            dispatch(showAlert('error', err?.message))
        }
    };
}

export const fetchNotificationLists = () => async dispatch => {
    try {
        dispatch(setNotificationListsLoading(true));
        const response = await axios.get(`${URL.NOTIF_LIST}`);
        if (response && response.data.success) {
            const data = get(response, 'data.objects', []);
            dispatch(setNotificationLists(data));
            dispatch(setNotificationListsLoading(false));
            return data
        }
        dispatch(setNotificationListsLoading(false));
    } catch (err) {
        dispatch(setNotificationListsLoading(false));
        if (err?.message) {
            dispatch(showAlert('error', err?.message))
        }
    };
}

export const createNotificationList = (payload) => async dispatch => {
    try {
        const response = await axios.post(`${URL.NOTIF_LIST}`, payload);
        if (response && response.data.success) {
            const data = get(response, 'data.object', {});
            dispatch(fetchNotificationLists())
            return data
        } else if (response?.data?.message) {
            dispatch(showAlert('error', response?.data?.message))
        }
    } catch (err) {
        if (err?.message) {
            dispatch(showAlert('error', err?.message))
        }
    };
}

export const editNotificationList = (payload) => async dispatch => {
    try {
        const response = await axios.put(`${URL.NOTIF_LIST}`, payload);
        if (response && response.data.success) {
            const data = get(response, 'data.object', {});
            dispatch(fetchNotificationLists())
            return data
        } else if (response?.data?.message) {
            dispatch(showAlert('error', response?.data?.message))
        }
    } catch (err) {
        if (err?.message) {
            dispatch(showAlert('error', err?.message))
        }
    };
}

export const deleteNotificationList = (listId) => async dispatch => {
    try {
        const response = await axios.delete(`${URL.NOTIF_LIST}` + `/${listId}`);
        if (response && response.data.success) {
            dispatch(fetchNotificationLists())
            return true
        } else if (response?.data?.message) {
            dispatch(showAlert('error', response?.data?.message))
        }
    } catch (err) {
        if (err?.message) {
            dispatch(showAlert('error', err?.message))
        }
    };
}


export const fetchCustomerReviewsByStatus = (status, pagination) => async dispatch => {
    try {
        dispatch(setFilteredCustomerReviewsLoading(true));
        const response = await axios.get(`${URL.SUPERADMIN_REVIEWS}-by-status?moderationStatus=${status}&${pagination}`);
        if (response && response.data.success) {
            const data = get(response, 'data.objects', []);
            dispatch(setFilteredCustomerReviews(data));
            dispatch(setFilteredCustomerReviewsLoading(false));
            return response?.data
        }
        dispatch(setFilteredCustomerReviewsLoading(false));
    } catch (err) {
        dispatch(setFilteredCustomerReviewsLoading(false));
        if (err?.message) {
            dispatch(showAlert('error', err?.message))
        }
    };
}

export const updateCustReviewModerationStatus = (rewiewIds = [], status = "APPROVED", currentFilter="PENDING") => async dispatch => {
    try {
        const payload = {
            moderationStatus: status,
            reviewIds: rewiewIds
        }
        const response = await axios.put(`${URL.SUPERADMIN_REVIEWS}/approve`, payload);
        if (response && response.data.success) {
            dispatch(showAlert('success', "Customer review status updated!!"));
            const data = get(response, 'data.object', {});
            dispatch(fetchCustomerReviewsByStatus(currentFilter))
            return data
        } else if (response?.data?.message) {
            dispatch(showAlert('error', response?.data?.message))
        }
    } catch (err) {
        if (err?.message) {
            dispatch(showAlert('error', err?.message))
        }
    };
}